export function extractDate(timestamp) {
  return timestamp.substring(0, 10);
}
